import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CalamityActionModel } from 'app/calamity/models/calamity-action.model';
import { GenericService } from 'app/_services/generic.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})

export class CalamityActionService extends GenericService<CalamityActionModel> {
    constructor(private http: HttpClient) {
        super(http, '/CalamityAction/')
    }

    public getActionsByCalamityId (calamityId : string) : Observable<CalamityActionModel[]> {
        return this._http.get(this.rootUrl +"/CalamityAction/getByCalamityId/"+ calamityId, this.prepareHeader()).pipe(map(res => res as CalamityActionModel[]))
    }
}